export const legacyHomeVideo = "/videos/home-image-band-preview.mp4";

export function getHomeVideoSources(mobile: boolean, base: string) {
  if (!base) return { mp4: legacyHomeVideo, hls: null };
  const prefix = `${base.replace(/\/+$/, "")}/home-image-band/v1/${mobile ? "mobile" : "desktop"}`;
  return {
    hls: `${prefix}/master.m3u8`,
    mp4: `${prefix}/full/video.mp4`,
  };
}

// This is a public asset URL, never an R2 access key or S3 API endpoint.
export const homeVideoBase = import.meta.env.VITE_VIDEO_CDN_BASE_URL ||
  (import.meta.env.DEV ? "/videos/optimized" : "");
